export default __webpack_public_path__ + "static/media/FeverInTheOceans_07.3aaa06dc.png";